<template>
  <div class="recruit">
    <Menu></Menu>
    <Tabber
      :tabberData="tabberData"
      :activeIndex="activeIndex"
      :tabTitle="tabTitle"
      @changeTabber="changeTabber"
    >
      <div class="recruitWrap" slot="tabberContent">
        <div class="recruitSection" v-show="activeIndex == 1&&!isLook" ref="pxfz"></div>
        <div class="recruitSection" v-show="activeIndex == 2&&!isLook">
          <el-carousel
            height="450px"
            trigger="click"
            arrow="never"
            :autoplay="false"
          >
            <el-carousel-item v-for="(val, key) in objList" :key="key">
              <div class="recruitListWrap" v-for="item in val" :key="item.id" @click="lookInfo(item)">
                <h4 class="recruitListTitle">{{ item.title }}</h4>
                <div class="recruitRequire">
                  <div class="recruitRequireList">
                    <i class="iconfont">&#xe91a;</i>
                    <span>面议</span>
                  </div>
                  <div class="recruitRequireList">
                    <i class="iconfont">&#xe633;</i>
                    <span>{{ item.location }}</span>
                  </div>
                  <div class="recruitRequireList">
                    <i class="iconfont">&#xe663;</i>
                    <span>{{ item.education }}</span>
                  </div>
                  <div class="recruitRequireList">
                    <i class="iconfont">&#xe613;</i>
                    <span>{{ item.workYears }}</span>
                  </div>
                  <div class="recruitRequireList">
                    <i class="iconfont">&#xe623;</i>
                    <span>{{ item.numNeed }}人</span>
                  </div>
                </div>
                <div class="recruitContent">
                  <h5 class="recruitTitle">岗位职责:</h5>
                  <div class="recruitList" v-html="item.workContent"></div>
                </div>
                <div class="recruitContent">
                  <h5 class="recruitTitle">任职资格:</h5>
                  <p class="recruitList" v-html="item.workStatus"></p>
                </div>
                <div class="recruitContent">
                  <h5 class="recruitTitle">薪酬福利:</h5>
                  <div class="recruitList" v-html="item.postRequest"></div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <div class="recruitSection" v-show="isLook" v-for="item in lookData" :key="item.id">
          <!-- <button @click="goBack()">点我试试看</button> -->
           <div class="lookTitle">
               {{item.title}}
           </div>
           <div class="gznr">
               <p class="lineH">岗位职责：</p>
               <div class="lineH" v-html="item.workContent"></div>
           </div>
           <div class="rzzg">
               <p class="lineH">任职资格：</p>
               <div class="lineH" v-html="item.workStatus"></div>
           </div>
           <div class="gwzz">
               <p class="lineH">薪酬福利：</p>
               <div class="lineH" v-html="item.postRequest"></div>
           </div>
           <div class="look-b">
               <p>简历投递邮箱6912405@qq.com，也可直接上51Job、BOSS上搜索“湖北光舜科技有限公司”，了解职位详情，申请简历投递。</p>
               <!-- <p>联系人：杨女士</p>
               <p>电  话：027-86699488</p> -->
           </div>
        </div>
      </div>
    </Tabber>
  </div>
</template>
<script>
import { getSysTrain, getRecruitList } from "@/api/manage";
import Menu from "../../components/menu/menu.vue";
import Tabber from "../../components/menu/tabber.vue";
export default {
  components: { Menu, Tabber },
  data() {
    return {
      active: false,
      tabberData: [
        // { id: "1", name: "培训发展" },
        { id: "2", name: "人才招聘" },
      ],
      activeIndex: "1",
      tabTitle: "人才招聘",
      objList: {},//数据源
      isLook:false,//是否点击进入了人才招聘详情，默认为false
      lookData:[]//进入详情之后，展示的数据
    };
  },
  watch: {
    $route(to, form) {
      this.activeIndex = to.params.id;
      this.isLook=false
      window.scrollTo(0, 0);
      this.getData(this.activeIndex);
    },
  },
  created() {
    this.activeIndex = this.$route.params.id;
    this.isLook=false
    this.getData(this.activeIndex);
  },
  mounted(){
  window.scrollTo(0, 0);
  },
  methods: {
  //   goBack(){
  //  this.$router.go(-1)
  //   },
    changeTabber(index) {//人才招聘页   tab栏切换
        this.isLook=false
      this.activeIndex = index;
      this.$router.push({ name: "recruit", params: { id: index } });
      this.newData = [];
    },
    lookInfo(data){//查看招聘信息详情
    this.lookData=[data]
    this.isLook=true
    },
    async getData(index) {//获取数据
      if (index == 1) {
        let res = await getSysTrain();
        if (res.data) {
          this.$refs["pxfz"].innerHTML = "";
          let text = decodeURI(res.data.text);
          this.$refs["pxfz"].innerHTML += text;
        }
      } else if (index == 2) {
        let res = await getRecruitList({ pageNo: 1, pageSize: 999 ,sortType:'a'});
        if (res.data) {
          let flag = 1;
          let arr = [];
          let obj = {};
          res.data.forEach((item, index) => {
            //将数据分为3个3个一组
            item.postRequest = item.postRequest.replace(
              /(\r\n|\n|\r)/gm,
              "<br />"
            ); //识别↵，并将其转换为换行符
            item.workContent = item.workContent.replace(
              /(\r\n|\n|\r)/gm,
              "<br />"
            );//识别↵，并将其转换为换行符
            item.workStatus = item.workStatus.replace(
              /(\r\n|\n|\r)/gm,
              "<br />"
            );//识别↵，并将其转换为换行符
            if (index == res.data.length - 1) {//当前循环的对象为数组末尾的一个
              arr.push(item);
              obj[flag] = JSON.parse(JSON.stringify(arr));
            } else if (arr.length < 2) {
              arr.push(item);
            } else if (arr.length == 2) {
              arr.push(item);
              obj[flag] = JSON.parse(JSON.stringify(arr));
              arr = [];
              flag = flag + 1;
            }
          });
          if (res.data.length <= 3) {
            obj[1] = res.data;
          }
          console.log('obj',obj);
          this.objList = obj;
        }
      }
    },
  },
};
</script>
<style scoped>
.recruitListTitle {
  font-size: 18px;
  color: #333;
  margin: 10px 0;
  text-align: center;
  margin-bottom: 20px;
}
.recruitWrap /deep/ .el-carousel__button {
  border: 1px solid #ccc;
  width: 8px;
  height: 8px;
  border-radius: 4px;
}

.recruitRequire {
  display: flex;
  flex-wrap: wrap;
}
.recruitRequireList {
  width: 33%;
}
.recruitRequireList img {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 5px;
}
.recruitRequireList span {
  vertical-align: middle;
  font-size: 14px;
}
.recruitList {
  font-size: 14px;
  line-height: 28px;
  color: #666;
}
.recruitContent {
  margin-top: 15px;
}
.recruitTitle {
  font-size: 14px;
}
.recruitListWrap {
  width: 430px;
  height: 94%;
  overflow: hidden;
  padding: 0 40px;
  display: inline-block;
  border-right: 1px solid #efefef;
  box-sizing: border-box;
}
.recruitListWrap:hover{
    cursor: pointer;
}
.recruitWrap .el-carousel__button {
  background-color: #438fed !important;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
.recruitRequireList i {
  color: #ccc;
  font-size: 19px;
  line-height: 100%;
  margin-right: 10px;
  line-height: 23px;
  padding-top: 3px;
}
.lookTitle{
    font-size: 19px;
}
.gznr{
    margin-top: 45px;
}
.gwzz,.rzzg{
    margin-top: 40px;
}
.look-b{
    margin-top: 40px;
    color:#696969
}
.look-b p{
    height: 30px;
}
.recruitSection .lineH{
  line-height: 30px;
}
</style>